import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Cart.css";
import { CartContext } from "../context/CartContext";

function Cart() {
  const navigate = useNavigate();
  const {
    cartItems,
    increaseQty,
    decreaseQty,
    removeFromCart,
    clearCart,
    totalPrice,
  } = useContext(CartContext);

  const handleBuyNow = () => {
    // ✅ Supports both "currentUser" and "loggedInUser"
    const currentUser =
      JSON.parse(localStorage.getItem("currentUser")) ||
      JSON.parse(localStorage.getItem("loggedInUser"));

    // 🔒 Check login status
    if (!currentUser) {
      alert("Please log in to complete your purchase.");
      navigate("/login");
      return;
    }

    // 🛒 Check if cart is empty
    if (cartItems.length === 0) {
      alert("Your cart is empty.");
      return;
    }

    // 🗂️ Create a user-specific key for orders
    const username = currentUser.username || currentUser.name || currentUser.email;
    const userOrdersKey = `orders_${username}`;
    const existingOrders = JSON.parse(localStorage.getItem(userOrdersKey)) || [];
    const date = new Date().toLocaleString();

    // 🆕 Add the new orders
    const newOrders = cartItems.map((item) => ({
      ...item,
      date,
    }));

    // 💾 Save orders only for this user
    localStorage.setItem(userOrdersKey, JSON.stringify([...existingOrders, ...newOrders]));

    clearCart();
    alert("Thank you for your purchase!");
  };

  return (
    <div className="cart-page">
      <h1>Your Shopping Cart</h1>

      {/* If cart is empty */}
      {cartItems.length === 0 ? (
        <p className="empty-cart">Your cart is empty.</p>
      ) : (
        <>
          <div className="top-actions">
            <button className="shop-more-btn" onClick={() => navigate("/products")}>
              Shop More
            </button>
          </div>

          {/* List of cart items */}
          <div className="cart-items">
            {cartItems.map((item) => (
              <div key={item.uniqueId} className="cart-item">
                <img src={item.images?.[0] ?? "placeholder.png"} alt={item.name} />
                <div className="cart-item-details">
                  <h3>{item.name}</h3>
                  <p>Price: ₹{item.price}</p>
                  <div className="quantity-controls">
                    <button onClick={() => decreaseQty(item.uniqueId)}>-</button>
                    <span>{item.quantity || 1}</span>
                    <button onClick={() => increaseQty(item.uniqueId)}>+</button>
                  </div>
                  <p>Subtotal: ₹{(item.price || 0) * (item.quantity || 1)}</p>
                  <button className="remove-btn" onClick={() => removeFromCart(item.uniqueId)}>
                    Remove
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* Cart summary and Buy Now button */}
          <div className="cart-summary">
            <h2>Total: ₹{totalPrice}</h2>
            <button onClick={handleBuyNow}>Buy Now</button>
          </div>
        </>
      )}
    </div>
  );
}

export default Cart;